import React from "react";
import { escapeRegex } from '../../../../common/utility/regex';

export default class  extends React.Component {
  renderHighlightedTitle(title, keyword) {
    if (!keyword) {
      return title;
    }

    const reg = new RegExp(escapeRegex(keyword), 'gi');
    const parts = String(title || '').split(reg);
    const matches = String(title || '').match(reg) || [];
    const nodes = [];

    for (let i = 0; i < parts.length; i++) {
      if (parts[i]) {
        nodes.push(parts[i]);
      }
      if (matches[i]) {
        nodes.push(<strong key={`${title}-${i}`}>{matches[i]}</strong>);
      }
    }

    return nodes;
  }

  render() {
    const {keyword, list, meta, router, listIndex} = this.props;

    if (!keyword) {
      return null;
    }

    const lis = list.map((item, index) => {
      const title = this.renderHighlightedTitle(item.title, keyword);
      return (
        <li className={index === listIndex ? 'pubhub-nav-search-list-item-active' : undefined} key={item.sequence}>
          <a
            href={item.url}
            onClick={(event) => {
              if (router.mode === 'history') {
                event.preventDefault();
                router.queryString = item.url.replace(router.baseURL, '');
              }
            }}
          >
            {title}
          </a>
        </li>
      );
    });

    return (
      <div className="pubhub-nav-search-list">
        <ul>{lis}</ul>
        {meta.indexed && (
          <a
            className="searchContent"
            href={`#search/${encodeURIComponent(keyword)}`}
            onClick={(event) => {
              if (router.mode === 'history') {
                event.preventDefault();
                router.queryString = `search/?q=${encodeURIComponent(keyword)}`;
              }
            }}
          >
            See all results for "{keyword}"
          </a>
        )}
      </div>
    )
  }
}
